import React from 'react';

import DashboardIcon from '@mui/icons-material/Dashboard';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import PeopleIcon from '@mui/icons-material/People';
import BarChartIcon from '@mui/icons-material/BarChart';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

import {createSvgIcon} from '@mui/material/utils';

const ExportIcon = createSvgIcon(
  <path d='M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z' />,
    'SaveAlt',
);

export {
  MenuIcon,
  DashboardIcon,
  PeopleIcon,
  BarChartIcon,
  ChevronLeftIcon,
  NotificationsIcon,
  ExpandLessIcon,
  ExpandMoreIcon,
  ExitToAppIcon,
  CurrencyExchangeIcon,
  ExportIcon,
  CheckCircleOutlineIcon,
  DoneIcon,
  CloseIcon,
};
